import { render } from "./FocusGroupDialog.vue?vue&type=template&id=32585f77&scoped=true"
import script from "./FocusGroupDialog.vue?vue&type=script&lang=js"
export * from "./FocusGroupDialog.vue?vue&type=script&lang=js"

import "./FocusGroupDialog.vue?vue&type=style&index=0&id=32585f77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32585f77"]])

export default __exports__